import React from "react";
import Tab from "./Tab";
import plusPng from './../assets/plus.png';
import Unit from "./SchedulePanel/Unit";

const UNSELECTED_COLOR = '#99E1FF';

const styles = {
    tabsWrapper: {
        display: 'flex',
        flexDirection: 'row'
    }
};

const getLoadingTabs = function() {
    const result = [];
    for(let i = 0; i < 8; i++) {
        result.push(
            <Tab
                name={ "" }
                id={ 0 }
                key={ "" }
                onSwitchPlan={ () => {} }
                isCurrentPlan={ i === 0 }
                openDeletePlanPopup={ () => {} }
                isLoading={true}
                isFirst={ i === 0 }
            />
        )
    }
    return result;
}

class Tabs extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: props.isLoading
        }
        this.loadingTabs = getLoadingTabs();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(prevProps.isLoading !== this.props.isLoading) {
            this.setState({isLoading: this.props.isLoading});
        }
    }

    render() {
        return (
            <div style={ styles.tabsWrapper }>
                { this.props.plans.map((plan) => <Tab
                    name={ plan.name }
                    id={ plan._id }
                    key={ plan._id }
                    onSwitchPlan={ this.props.onSwitchPlan }
                    isCurrentPlan={ this.props.currentPlanId === plan._id }
                    openDeletePlanPopup={ () => this.props.openDeletePlanPopup(plan._id) }
                />) }
                {
                    this.state.isLoading && this.loadingTabs
                }
                <div onClick={ this.props.openAddPlanPopup }
                     style={{ backgroundColor: UNSELECTED_COLOR, height: 24, width: 24,
                         borderRadius: '5px 5px 0px 0px', paddingTop: 7, paddingLeft: 7 }}>
                    <img src={plusPng} style={{ width: 16, height: 16 }} />
                </div>
            </div>
        );
    }
}

export default Tabs;